(() => {
  'use strict';
  const source = document.getElementById('adler-refinement-messages');
  let messages = {};
  try { messages = JSON.parse(source?.textContent || '{}'); } catch (_) {}
  window.adlerRefinement = messages;
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(cents / 100);
  const refreshCart = async () => {
    try {
      const response = await fetch(root + 'cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.cart-count').forEach(node => { node.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (_) {}
  };
  const addItems = async items => {
    const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || messages.error);
    await refreshCart();
    return result;
  };
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-card-buy]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    const button = form.querySelector('button');
    const status = form.parentElement.querySelector('.adler-card-feedback');
    const data = new FormData(form);
    form.dataset.busy = 'true'; button.disabled = true; form.setAttribute('aria-busy', 'true');
    status.hidden = true;
    try {
      await addItems([{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) }]);
      status.textContent = messages.added + ' · ';
      const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = messages.cart; status.append(link);
    } catch (error) { status.textContent = error.message; }
    finally { status.hidden = false; button.disabled = false; delete form.dataset.busy; form.removeAttribute('aria-busy'); }
  });
  const hover = window.matchMedia('(hover:hover) and (pointer:fine)');
  document.addEventListener('pointerover', event => {
    if (!hover.matches || event.pointerType === 'touch') return;
    const card = event.target.closest('.adler-product-card--compact');
    if (!card || card.contains(event.relatedTarget)) return;
    const details = card.querySelector('.adler-card-options');
    if (details && !details.open) { details.open = true; details.dataset.hoverOpen = 'true'; }
  });
  document.addEventListener('pointerout', event => {
    const card = event.target.closest('.adler-product-card--compact');
    if (!card || card.contains(event.relatedTarget)) return;
    const details = card.querySelector('.adler-card-options');
    if (details?.dataset.hoverOpen && !details.contains(document.activeElement)) { details.open = false; delete details.dataset.hoverOpen; }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.adler-card-options');
    if (details) { details.open = false; delete details.dataset.hoverOpen; details.querySelector('summary').focus(); }
  });
  const initializeFilters = panel => {
    const section = panel.closest('[data-adler-collection]');
    const grid = section.querySelector('.adler-commerce-grid');
    if (!grid) return;
    const selectors = [...panel.querySelectorAll('[data-card-filter]')];
    const status = panel.querySelector('[role=status]');
    let ready = false, busy = false;
    const filter = () => {
      let count = 0;
      grid.querySelectorAll('.adler-product-card').forEach(card => {
        const matched = selectors.every(select => !select.value || card.getAttribute('data-card-' + select.dataset.cardFilter) === select.value);
        card.hidden = !matched; if (matched) count++;
      });
      status.textContent = count ? count + ' ' + messages.count : messages.no_results;
    };
    panel.addEventListener('toggle', async () => {
      if (!panel.open || ready || busy) return;
      busy = true; status.textContent = messages.loading;
      try {
        const cards = [], seen = new Set();
        let next = new URL(window.location.href);
        next.searchParams.set('page', '1'); next.searchParams.set('section_id', panel.dataset.sectionId);
        while (next) {
          const key = next.href; if (seen.has(key)) throw new Error('Pagination loop'); seen.add(key);
          const response = await fetch(next); if (!response.ok) throw new Error('Collection unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = html.querySelector('[data-adler-collection]'); if (!result) throw new Error('Collection missing');
          cards.push(...result.querySelectorAll('.adler-commerce-grid > .adler-product-card'));
          const link = result.querySelector('[data-next-page]');
          next = link ? new URL(link.getAttribute('href'), window.location.origin) : null;
          if (next) next.searchParams.set('section_id', panel.dataset.sectionId);
        }
        if (!cards.length) throw new Error('Collection empty');
        selectors.forEach(select => {
          const values = [...new Set(cards.map(card => card.getAttribute('data-card-' + select.dataset.cardFilter)).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'de'));
          select.replaceChildren(new Option(messages.all, ''));
          values.forEach(value => select.add(new Option(value, value)));
          select.disabled = false;
        });
        grid.replaceChildren(...cards);
        section.querySelectorAll('.adler-pagination').forEach(nav => { nav.hidden = true; });
        ready = true; filter();
      } catch (_) { status.textContent = messages.filter_error; }
      finally { busy = false; }
    });
    selectors.forEach(select => select.addEventListener('change', filter));
    panel.querySelector('[data-filter-reset]').addEventListener('click', () => { selectors.forEach(select => { select.value = ''; }); if (ready) filter(); });
  };
  document.querySelectorAll('[data-extra-filters]').forEach(initializeFilters);
  const initializeQuickOrder = box => {
    const rows = box.querySelector('[data-quick-rows]');
    const add = box.querySelector('[data-quick-add]');
    const status = box.querySelector('[data-quick-status]');
    let index = 0, submitting = false;
    const validRows = () => [...rows.children].filter(row => row.querySelector('[data-quick-sku]').value.trim());
    const update = () => { const entries = validRows(); add.disabled = submitting || !entries.length || entries.some(row => !row.variant || !row.querySelector('[data-quick-qty]').checkValidity()); };
    const newRow = () => {
      index++;
      const row = document.createElement('div'); row.className = 'adler-quick-row';
      const skuLabel = document.createElement('label'); skuLabel.textContent = messages.sku;
      const sku = document.createElement('input'); sku.dataset.quickSku = ''; sku.type = 'text'; sku.autocomplete = 'off'; sku.id = 'quick-sku-' + index; skuLabel.htmlFor = sku.id; skuLabel.append(sku);
      const qtyLabel = document.createElement('label'); qtyLabel.textContent = messages.quantity;
      const qty = document.createElement('input'); qty.dataset.quickQty = ''; qty.type = 'number'; qty.min = '1'; qty.step = '1'; qty.value = '1'; qty.required = true; qty.id = 'quick-qty-' + index; qtyLabel.htmlFor = qty.id; qtyLabel.append(qty);
      const lookup = document.createElement('button'); lookup.type = 'button'; lookup.dataset.quickLookup = ''; lookup.textContent = messages.lookup;
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.quickRemove = ''; remove.textContent = '×'; remove.setAttribute('aria-label', messages.remove);
      const result = document.createElement('div'); result.className = 'adler-quick-result'; result.setAttribute('role', 'status');
      row.append(skuLabel, qtyLabel, lookup, remove, result); rows.append(row);
      const invalidate = () => { row.variant = null; row.lookupVersion = (row.lookupVersion || 0) + 1; result.textContent = ''; update(); };
      sku.addEventListener('input', invalidate); qty.addEventListener('input', update);
      remove.addEventListener('click', () => { row.remove(); if (!rows.children.length) newRow(); update(); });
      sku.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); lookup.click(); } });
      lookup.addEventListener('click', async () => {
        const value = sku.value.trim(); if (!value) { sku.focus(); return; }
        invalidate(); const version = row.lookupVersion; lookup.disabled = true; result.textContent = messages.loading;
        try {
          const url = new URL(root + 'search', window.location.origin); url.searchParams.set('type', 'product'); url.searchParams.set('q', value); url.searchParams.set('view', 'quick-order');
          const response = await fetch(url); if (!response.ok) throw new Error(messages.lookup_error);
          const data = await response.json(); if (version !== row.lookupVersion) return;
          const matches = data.variants.filter(variant => [variant.sku,variant.barcode].some(code => code?.trim().toLowerCase() === value.toLowerCase()));
          if (matches.length !== 1 || !matches[0].available) throw new Error(messages.not_found);
          row.variant = matches[0];
          const variant = row.variant; qty.min = String(variant.min); qty.step = String(variant.step); if (variant.max) qty.max = String(variant.max); else qty.removeAttribute('max');
          if (!qty.checkValidity()) qty.value = String(variant.min);
          const link = document.createElement('a'); link.href = variant.url; link.textContent = variant.title + (variant.variant === 'Default Title' ? '' : ' · ' + variant.variant);
          result.replaceChildren(link, document.createTextNode(' · ' + variant.sku + ' · ' + money(Math.round(variant.price / 1.19)) + ' ' + messages.net));
        } catch (error) { if (version === row.lookupVersion) { row.variant = null; result.textContent = error.message || messages.lookup_error; } }
        finally { lookup.disabled = false; update(); }
      });
      return sku;
    };
    for (let i = 0; i < 3; i++) newRow();
    box.querySelector('[data-quick-more]').addEventListener('click', () => newRow().focus());
    add.addEventListener('click', async () => {
      const entries = validRows();
      if (submitting || !entries.length || entries.some(row => !row.variant || !row.querySelector('[data-quick-qty]').reportValidity())) { status.textContent = messages.choose_sku; return; }
      const items = new Map(); entries.forEach(row => { const id = row.variant.id; items.set(id, (items.get(id) || 0) + Number(row.querySelector('[data-quick-qty]').value)); });
      submitting = true; const controls = [...box.querySelectorAll('button,input')].filter(node => !node.disabled); controls.forEach(node => { node.disabled = true; }); status.textContent = messages.loading;
      try {
        await addItems([...items].map(([id, quantity]) => ({ id, quantity })));
        status.textContent = messages.added; entries.forEach(row => row.remove()); if (!rows.children.length) newRow();
      } catch (error) { status.textContent = error.message; }
      finally { controls.forEach(node => { node.disabled = false; }); submitting = false; update(); }
    });
  };
  document.querySelectorAll('[data-quick-order]').forEach(initializeQuickOrder);
  document.querySelectorAll('[data-shipping-estimator]').forEach(box => {
    if (box.closest('[data-adler-net-cart]')) return;
    const input = box.querySelector('[data-shipping-zip]'), button = box.querySelector('[data-shipping-calculate]'), output = box.querySelector('[data-shipping-result]');
    const clear = () => { output.textContent = messages.changed; };
    input.addEventListener('input', clear);
    box.closest('form')?.querySelectorAll('[name="updates[]"]').forEach(field => field.addEventListener('input', () => { clear(); button.disabled = true; }));
    button.addEventListener('click', async () => {
      input.required = true; if (!input.reportValidity()) return;
      const zip = input.value.trim(); button.disabled = true; output.textContent = messages.loading;
      const query = new URLSearchParams({ 'shipping_address[zip]': zip, 'shipping_address[country]': 'Germany' });
      try {
        const prepare = await fetch(root + 'cart/prepare_shipping_rates.json?' + query, { method: 'POST' });
        if (!prepare.ok) throw new Error();
        let result = null;
        for (let i = 0; i < 8 && !result; i++) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          const response = await fetch(root + 'cart/async_shipping_rates.json?' + query); if (!response.ok) throw new Error(); result = await response.json();
        }
        if (input.value.trim() !== zip) { clear(); return; }
        if (!result) throw new Error();
        output.replaceChildren();
        if (!result.shipping_rates?.length) { output.textContent = messages.rate_empty; return; }
        result.shipping_rates.forEach(rate => { const paragraph = document.createElement('p'); paragraph.textContent = (rate.presentment_name || rate.name) + ': ' + money(Math.round(Number(rate.price) * 100), rate.currency || box.dataset.currency); output.append(paragraph); });
        const note = document.createElement('small'); note.textContent = messages.rate_note + ' ' + messages.rate_tax; output.append(note);
      } catch (_) { output.textContent = messages.rate_error; }
      finally { button.disabled = false; input.required = false; }
    });
  });
})();


